
import appSettingContext from '!raw-loader!../../static/appSetting.json'

export function readAppSetting() {
    const appSetting = JSON.parse(appSettingContext);
    return appSetting;
}



// WEBPACK FOOTER //
// ./src/libs/appSettingUtils.js